import { amIPrerender } from '@app/utils/botUtils';

export function isIntersectionObserverAvailable() {
    return !!window.IntersectionObserver
        && !!window.IntersectionObserverEntry
        && !amIPrerender();
}
